import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export function Navbar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          🎰 Casino
        </Link>

        <div className="navbar-menu">
          <Link to="/" className="navbar-link">Etusivu</Link>
          <Link to="/game/slots" className="navbar-link">Kolikkopeli</Link>

          {currentUser ? (
            <>
              <Link to="/profile" className="navbar-link">Profiili</Link>
              <span className="navbar-user">{currentUser.displayName || currentUser.email}</span>
              <button onClick={handleLogout} className="navbar-button">Kirjaudu ulos</button>
            </>
          ) : (
            <>
              <Link to="/login" className="navbar-link">Kirjaudu</Link>
              <Link to="/register" className="navbar-button">Rekisteröidy</Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
